import ChargerModule from 'components/chargerModule';
import LogisticServiceEditionModule from './LogisticServiceEditionModule';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ILogisticServiceWithProductPrices } from 'types/services';
import { useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { getLogisticServiceWithProductPrices } from 'services/priceEdition/logisticServicesPriceEdition.service';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import { getPermissionsByModule } from 'utils/permissions';
import { BACKOFFICE_MODULES } from 'types/configuration.types';

const LogisticServiceEdition = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { state }: { state: { LSData: ILogisticServiceWithProductPrices } } = useLocation();
  const { logisticServiceId } = useParams<{ logisticServiceId: string }>();
  const { replace } = useHistory();
  const [LSData, setLSData] = useState<ILogisticServiceWithProductPrices | undefined>();

  const validatePermissions = () => {
    const editPricesPermissions = getPermissionsByModule({ moduleName: BACKOFFICE_MODULES.EDIT_PRICES });
    if (!editPricesPermissions.read || !editPricesPermissions.edit) {
      replace('/unauthorized');
    }
  };

  const getLSData = async () => {
    try {
      setIsLoading(true);
      const response = await getLogisticServiceWithProductPrices(logisticServiceId);
      response.billingData =
        typeof response?.billingData === 'string' ? JSON.parse(response?.billingData) : response?.billingData;
      response.products = response?.products?.map(product => ({
        ...product,
        logisticServiceProductPrices:
          product?.logisticServiceProductPrices?.map(service => ({
              ...service,
              totalValueLocal: service?.totalValueLocal
                ? service?.totalValueLocal
                : Number(service?.totalValueUsd) * Number(service?.exchangeRate)
            })) ?? []
      }));
      setLSData(response);
    } catch (error) {
      displayErrorNotification({ customJSXMessage: <>Ocurrió un error al obtener los datos del servicio</> });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    validatePermissions();
    getLSData();
  }, [state]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ChargerModule
      infoSideBar={{ position: 'logisticService' }}
      headerInfo={{ title: 'Edición del servicio', subtitle: `- N°${logisticServiceId}` }}
    >
      {!isLoading && LSData ? (
        <LogisticServiceEditionModule LSData={LSData} onDataReload={getLSData} />
      ) : (
        <div style={{ display: 'grid', placeItems: 'center', height: '100%' }}>
          <LoadingOutlined style={{ color: '#070F21', fontSize: '50px' }} />
        </div>
      )}
    </ChargerModule>
  );
};

export default LogisticServiceEdition;
